import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {Application} from "../types.ts";
import {useApplication} from "../hooks/useApplication.ts";


export const AddFormDrawer = (props: DrawerProps) => {

    const {
        record,
        createRecord,
    } = useApplication();

    return (
        <FormDrawer
            record={record ?? {} as Application}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
